// extracted by mini-css-extract-plugin
export var divider = "_ga-7";
export var itemsToggle = "_ga-8";
export var mergeModal = "_ga-1";
export var optionCard = "_ga-4";
export var radioGroup = "_ga-6";
export var radioOption = "_ga-0";
export var selected = "_ga-5";
export var shipmentOptions = "_ga-2";
export var tableOptions = "_ga-3";